import React, { Fragment } from 'react';
import {
  CTAIconButton,
  CTAButtonWrapper,
  CTAButtonLink,
  CTAButton1Wrapper,
  CTAHeadlineText,
  CTAButtonLinkText
} from './components';
import { OwnUpGridItem, OwnUpGridContainer } from '@rategravity/own-up-component-library';
import { HomeBuyingIcon } from '../../../images/icons/home-buying';
import { HomeRefinancingIcon } from '../../../images/icons/home-refinancing';

const my = `https://${process.env.GATSBY_MY}`;
const www = `https://${process.env.GATSBY_WWW}`;

const CTAButtons1 = () => (
  <Fragment>
    <CTAButton1Wrapper>
      <OwnUpGridContainer variant="slim">
        <OwnUpGridItem xs={0} sm={1} md={1} lg={1} xl={2} />
        <OwnUpGridItem xs={12} sm={10} md={10} lg={10} xl={8}>
          <OwnUpGridItem>
            <CTAHeadlineText variant="h3">See What You Qualify For</CTAHeadlineText>
          </OwnUpGridItem>
          <OwnUpGridContainer variant="legacy">
            <OwnUpGridItem xs={12} sm={12} md={12} lg={6}>
              <CTAIconButton
                id="buying_blog"
                icon={<HomeBuyingIcon />}
                text="Buying"
                href={`${www}/onboarding/buying/`}
              />
            </OwnUpGridItem>
            <OwnUpGridItem xs={12} sm={12} md={12} lg={6}>
              <CTAIconButton
                id="refinancing_blog"
                icon={<HomeRefinancingIcon />}
                text="Refinancing"
                href={`${my}/onboarding/refinance/`}
              />
            </OwnUpGridItem>
          </OwnUpGridContainer>
          <CTAButtonWrapper>
            <CTAButtonLink id="get_started_blog" href={`${www}/onboarding/get-started/`}>
              <CTAButtonLinkText>Get Started</CTAButtonLinkText>
            </CTAButtonLink>
          </CTAButtonWrapper>
        </OwnUpGridItem>
        <OwnUpGridItem xs={0} sm={1} md={1} lg={1} xl={2} />
      </OwnUpGridContainer>
    </CTAButton1Wrapper>
  </Fragment>
);

export default CTAButtons1;
